import jwtDecode from 'jwt-decode';

// https://pinia.vuejs.org/core-concepts/#setup-stores
export const useAuthStore = defineStore('woom-store-auth', () => {
    const token = ref('');
    const jwt = ref<{ cartId?: string }>({});
    const woomSessionCookie = useCookie(WoomCookies.WoomSession);
    const checkToken = () => {
        if (!import.meta.client) return;
        if (!woomSessionCookie.value || token.value === woomSessionCookie.value) return;
        token.value = woomSessionCookie.value;
        jwt.value = jwtDecode(woomSessionCookie.value);
    };

    return {
        jwt,
        checkToken,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
